export const notificationRate = (count, targeted) => {
  const total = Number(targeted);
  const received = Number(count);
  if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(received) || received < 0) return 0;
  // Do not hide historical overcounting by capping the displayed percentage.
  return Math.round((received / total) * 100);
};
